import { Injectable } from "@angular/core";
import { ImageProcessingService } from "./image-processing.service";
import { environment } from "src/environments/environment";
import { Development } from "@models/development.model";
import { DevelopmentService } from "./development.service";

@Injectable({
  providedIn: "root",
})
export class CommonServiceService {
  constructor(
    private imageProcessingService: ImageProcessingService,
    private developmentService: DevelopmentService,
  ) {
    console.log("CommonServiceService");
  }

  removeStringAfterParenthesesAndTitleCase(value: string): string {
    if (value === undefined || value == "") return value;

    const startIndex = value.indexOf("(");
    if (startIndex !== -1) {
      value = value.substring(0, startIndex).trim();
    }

    const words = value.split(" ");
    const transformedWords = words.map((word) => {
      if (word === "II") {
        return word;
      } else {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
    });

    return transformedWords.join(" ");
  }

  IdentifyIssueWithFileandFolderNames(): void {
    this.developmentService.getItems().forEach((develop: Development) => {
      const containerUrl = environment.blobPhotos;
      this.imageProcessingService
        .getDevlopmentBlobs(containerUrl, develop.name)
        .subscribe((response) => {
          const photo = response.map((x) => {
            return containerUrl.concat(x);
          });

          photo.forEach((element) => {
            if (element.indexOf("#") !== -1)
              console.log({
                DevelopmentName: develop.name,
                imageLocation: element.replaceAll(environment.blobPhotos, ""),
              });
          });

          console.log({ photo });

          if (photo.length <= 0)
            console.log({ DevelopmentName: develop.name, imageLocation: photo });
        });
    });
  }
}
